module.exports = __webpack_public_path__ + "img/footer.2ca09078.png";